var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.809 44C6.454 44 .189 35.82.189 21.927.189 8.063 6.512 0 16.809 0c10.267 0 16.62 8.063 16.62 21.956C33.428 35.792 27.162 44 16.808 44zm0-7.135c4.814 0 7.744-5.134 7.744-14.938 0-9.745-2.959-14.763-7.744-14.763-4.757 0-7.745 5.047-7.745 14.763 0 9.775 2.959 14.938 7.745 14.938zM40.882 13.603C40.882 5.511 47.09 0 56.14 0c8.73 0 14.821 5.018 14.821 12.21 0 4.555-2.465 8.47-9.716 15.286l-8.006 7.629v.522H71.57v7.28H41.375v-6.12l13.662-13.371c5.888-5.743 7.367-7.918 7.367-10.645 0-3.364-2.727-5.743-6.555-5.743-4.06 0-6.845 2.669-6.845 6.526v.174h-8.122v-.145z",
    fill: "#F2F1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.65e589255062dce139b3353ddccf1c1b.svg";
export { ForwardRef as ReactComponent };